import React from 'react';

import { observer } from 'mobx-react';
import { getRoot } from 'mobx-easy';
import { RootStore } from '@bringg-frontend/global-stores';

import { ManagedAttributeMetadata, ManagedAttributesService } from '../index';
import { TaskLink } from './task/task-link';

export const getManagedAttributeValue = (attribute: ManagedAttributeMetadata, id: number): string => {
	const value = ManagedAttributesService.getAttributeByName(id, attribute.identifier);

	if (value && attribute.data_type.entity === 'driver') {
		const driver = getRoot<RootStore>().data.driversStore.get(Number(value));
		return driver?.name || (value as string);
	}

	const displayValue: string = ManagedAttributesService.formatManagedAttributeValue({
		attribute,
		context: 'order_explorer',
		value
	});

	return value === undefined ? '' : `${displayValue}`;
};

type ManagedAttributeCellProps = {
	attribute: ManagedAttributeMetadata;
	id: number;
};

const ManagedAttributeCell = ({ attribute, id }: ManagedAttributeCellProps) => {
	const value = getManagedAttributeValue(attribute, id);

	if (!value) return null;

	return (
		<div data-test-id={`managed-attribute-${attribute.identifier}`}>
			{attribute.data_type.entity === 'task' ? <TaskLink taskId={Number(value)} /> : value}
		</div>
	);
};

export default observer(ManagedAttributeCell);
